var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTelegramFull(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 15.672
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.317 7.515l4.152 1.543 1.6 5.162a.488.488 0 00.772.239l2.315-1.892a.689.689 0 01.845-.018l4.17 3.031a.494.494 0 00.772-.294l3.05-14.7a.487.487 0 00-.661-.551L.317 6.596a.491.491 0 000 .919zm5.493.716l8.1-5a.138.138 0 01.165.22L7.408 9.683a1.337 1.337 0 00-.423.827l-.22 1.692a.209.209 0 01-.4.037l-.882-3.086a.771.771 0 01.327-.922z",
    fill: "#fff"
  })));
}

export default __webpack_public_path__ + "static/media/telegram_full.d3bd7166969f19d1fa9ea758100ce089.svg";
export { SvgTelegramFull as ReactComponent };